import { Badge, Tooltip } from 'antd';
import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '../lib/api';
import { useApi } from './api-context';

const WEB_COMMIT = typeof __WEB_COMMIT__ === 'string' ? __WEB_COMMIT__ : 'dev';

export function apiStatusText(h: HealthResponse) {
  return h.commit ? `API ${h.version} · ${h.commit}` : `API ${h.version}`;
}

export function ApiStatus() {
  const api = useApi();
  const { data, isError, isPending } = useQuery({
    queryKey: ['health'],
    queryFn: () => api.get<HealthResponse>('/health'),
    retry: false,
    staleTime: 60_000,
  });
  if (isPending) return <Badge status="processing" text="API 확인 중" />;
  if (isError || !data?.ok) return <Badge status="error" text="API 연결 안 됨" />;
  // 로컬 미커밋 변경으로 배포된 함수는 경고 색으로 표시한다.
  const dirty = data.commit?.endsWith('-dirty');
  const built = data.builtAt ? new Date(data.builtAt).toLocaleString('ko-KR') : '알 수 없음';
  return (
    <Tooltip title={`웹 ${WEB_COMMIT} · API ${data.commit ?? '알 수 없음'} (함수 빌드 ${built})${dirty ? ' · 커밋하지 않은 변경으로 배포됨' : ''}`}>
      <Badge status={dirty ? 'warning' : 'success'} text={apiStatusText(data)} />
    </Tooltip>
  );
}
